import { useDeleteOrganizationInvitation, useUserRole } from "@/api";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@/components/ui/dropdown";
import { toast } from "@/components/ui/use-toast";
import { Ellipsis } from "lucide-react";

type Props = {
  invitationId: string;
};

export const InvitationAction = ({ invitationId }: Props) => {
  const { isAdmin } = useUserRole();

  const [deleteOrganizationInvitation] = useDeleteOrganizationInvitation();

  const handleDeleteOrganizationInvitation = (id: string) => {
    deleteOrganizationInvitation({ variables: { invitationId: id } })
      .then((res) => {
        if (
          res.data?.organizationInvitationDelete?.__typename ===
          "OrganizationNotFound"
        ) {
          toast({
            title: "Organization not found",
            description:
              "The organization to delete the invitation could not be found, please try again or report the issue."
          });
        }
        if (
          res.data?.organizationInvitationDelete?.__typename ===
          "OrganizationInvitationNotFound"
        ) {
          toast({
            title: "Invitation not found",
            description:
              "The invitation to delete could not be found, please try again or report the issue."
          });
        }
        if (
          res.data?.organizationInvitationDelete?.__typename ===
          "OrganizationInvitationDeleted"
        ) {
          toast({
            title: "Invitation was deleted",
            description: "The invitation has been successfully deleted."
          });
        }
      })
      .catch(() => {
        toast({
          title: "Network error",
          description:
            "A network error happened while trying to delete the invitation, please try again later or report the issue."
        });
      });
  };

  if (!isAdmin) return null;

  return (
    <div className="flex justify-end pr-2">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            data-testid="cancelInvitationButton"
            variant="ghost"
            className="h-8 w-8 p-0"
          >
            <span className="sr-only">Open menu</span>
            <Ellipsis className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem
            onClick={() => handleDeleteOrganizationInvitation(invitationId)}
            className="text-brand-error"
          >
            Cancel invitation
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
